<template>
  <InputNumberWithPopover 
    v-bind="$attrs"
    :modelValue="displayValue"
    @update:modelValue="handleInput"
    @change="handleChange"
  />
</template>
<script>
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover.vue';

export default {
  name: 'InputNumberWithPopoverUpsell',
  components: { InputNumberWithPopover },
  props: {
    oldNumber: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Number,
      required: true,
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    displayValue() {
      return this.modelValue - this.oldNumber;
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('update:modelValue', value + this.oldNumber);
    },
    handleChange(value) {
      this.$emit('change', value + this.oldNumber);
    },
  },
};
</script>